// Utilities
//import { make } from 'vuex-pathify'
// Globals
import { IN_BROWSER, AUTH_SUCCESS, AUTH_LOGOUT, MENU_SUCCESS } from '@/util/globals'

const state = {
  isLogin: localStorage.getItem("user") || false,
  token: "",
  fullName:"",
  userName:"",
  id:"",
  expiration:"",
  menuid:"",
}

const mutations = {
  [MENU_SUCCESS]: (state, resp) => {
    state.menuid = resp;
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.token = resp.token;
    state.userName = resp.userName;
    state.id = resp.id;
    state.fullName = resp.fullName;
    state.expiration = resp.expiration;
    state.isLogin = true;
  },
  [AUTH_LOGOUT]: state => {
    state.token = "";
    state.userName = "";
    state.id = "";
    state.fullName = "";
    state.expiration = "";
    state.isLogin = false;
  },
}

const actions = {
  fetch: ({ commit }) => {
    const local = localStorage.getItem('user') || '{}'
    const user = JSON.parse(local)
    commit(AUTH_SUCCESS,user);

    const mid = localStorage.getItem('mid') || ''
    commit(MENU_SUCCESS,mid);

  },
  login: ({  commit },data) => {
    if (!IN_BROWSER) return

    localStorage.setItem('user', JSON.stringify(data));
    
    commit(AUTH_SUCCESS,data);
    
    //commit("isLogin",true);

  },
  setMenu: ({  commit },data) => {
    if (!IN_BROWSER) return

    localStorage.setItem('mid', data);
    
    commit(MENU_SUCCESS,data);
    
    //commit("isLogin",true);

  },  
  logout: ({ commit }) => {
    return new Promise(resolve => {
      commit(AUTH_LOGOUT);
      localStorage.removeItem("user");
      resolve();
    });
  }
}

const getters = {
  token: (state) => {
    return (
      state.token
    )
  },
  userName: state => {
    return state.userName
  },
  fullName: state => {
    return state.fullName
  },
  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
